import { render, staticRenderFns } from "./metta-channel.vue?vue&type=template&id=4ecda98d&scoped=true"
import script from "./metta-channel.vue?vue&type=script&lang=js"
export * from "./metta-channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecda98d",
  null
  
)

export default component.exports